<template>
  <div
    :id="`quick-task-${isPostingSuccess ? 'posting' : 'scheduling'}-success`"
    class="flex flex-col items-center text-center"
  >
    <DotLottieVue
      class="h-full w-full max-w-72 max-h-72 mt-8"
      autoplay
      :loop-count="1"
      src="/animations/success.lottie"
    />
    <p
      class="font-semibold text-lg mb-2 opacity-0 animate-[fade-in-up_0.4s_0.5s_forwards]"
    >
      {{ isScheduleSuccess ? $t("contentScheduledTitle") : $t("contentPostedTitle") }}!
    </p>
    <p
      class="ma-text-secondary opacity-0 animate-[fade-in-up_0.4s_0.8s_forwards] max-w-md"
    >
      {{
        isScheduleSuccess
          ? $t("taskContentScheduledSuccess")
          : $t("taskContentPostedSuccess")
      }}
      {{ $t("postCompleteConfirmation") }}
    </p>

    <div
      class="flex flex-col gap-3 mt-6 @sm:mt-12 opacity-0 animate-[fade-in-up_0.4s_1.0s_forwards]"
    >
      <AppButton
        :label="$t('returnToContent')"
        class="return-to-content"
        :data-gtm-action="analyticsEvents.QUICK_TASK.quick_task_return_after_posting"
        @click="handleStay"
      />
      <AppButton
        variant="secondary"
        text
        class="create-new-content"
        :label="$t('createNewContent')"
        :data-gtm-action="
          analyticsEvents.QUICK_TASK.quick_task_another_task_after_posting
        "
        @click="handleRestart"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";

const { reset, isPostingSuccess, isScheduleSuccess } = useQuickTask();

function handleRestart() {
  reset();
  isPostingSuccess.value = false;
  isScheduleSuccess.value = false;
}

function handleStay() {
  isPostingSuccess.value = false;
  isScheduleSuccess.value = false;
}
</script>
